module.exports = __webpack_public_path__ + "img/p4.bbaee192.png";